"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var app_1 = require("firebase/app");
var firestore_1 = require("firebase/firestore");
var invoices_1 = require("../../models/invoices");
var shared_1 = require("../shared");
var UsersController = /** @class */ (function () {
    /**
     * Creates a Invoices controller instance with provided config to setup Firebase app.
     * @param {FirebaseOptions} config Firebase configuration to initialize app.
     */
    function UsersController(config) {
        var _this = this;
        /**
         * Gets a list of invoices
         * @param params.filter the filter parameters to narrow down the list of invoices
         * @param params.sort the sort parameters to sort the list of invoices
         * @param params.pagination the pagination parameters to page/limit the list of invoices
         * @returns a list of invoice objects, along with a total count of invoices satisfying all filters, irrespective of pagination
         */
        this.getList = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var _a, startIndex, endIndex, invoices;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = (0, shared_1.getPaginationSlice)(params.pagination), startIndex = _a.startIndex, endIndex = _a.endIndex;
                        return [4 /*yield*/, (0, invoices_1.list)(this.db, __assign({ filter: params.filter }, (params.sort && {
                                sort: __assign(__assign({}, params.sort), { order: params.sort.order === "ASC" ? "asc" : "desc" })
                            })))];
                    case 1:
                        invoices = _b.sent();
                        return [2 /*return*/, {
                                data: invoices.slice(startIndex, endIndex),
                                total: invoices.length
                            }];
                }
            });
        }); };
        /**
         * Gets a single invoices's details
         * @param params.id the invoices's id
         * @returns the invoice object
         */
        this.getOne = function (params) { return __awaiter(_this, void 0, void 0, function () {
            var invoice;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, invoices_1.get)(this.db, {
                            id: params.id
                        })];
                    case 1:
                        invoice = _a.sent();
                        return [2 /*return*/, { data: invoice }];
                }
            });
        }); };
        var firebaseApp = (0, app_1.initializeApp)(config);
        this.db = (0, firestore_1.getFirestore)(firebaseApp);
    }
    return UsersController;
}());
exports["default"] = UsersController;
